import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-036d9ca4")

_pushScopeId("data-v-036d9ca4")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "absolute top-4 left-4 w-48 h-32 demo" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ExampleImage = _resolveComponent("ExampleImage")

  return (_openBlock(), _createBlock(_component_ExampleImage, { class: "bg-cover" }, {
    default: _withId(() => [
      _hoisted_1
    ]),
    _: 1
  }))
})